import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ContactAdminModalComponent } from './contact-admin-modal/contact-admin-modal.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-access-denied',
  template: './access-denied.html',
  styles: ['./access-denied.scss']
})
export class AccessDeniedPage {
  currentIp: string = this.translate.instant('COMMON.LOADING');

  constructor(
    private modalCtrl: ModalController,
    private translate: TranslateService
  ) {

    const storedIp = localStorage.getItem('last_checked_ip');
    if (storedIp) {
      this.currentIp = storedIp;
    }
  }

  async openContactAdminModal() {
    const modal = await this.modalCtrl.create({
      component: ContactAdminModalComponent,
      cssClass: 'contact-admin-modal'
    });
    return await modal.present();
  }
}